<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="전시관리">

            <b-row align-v="center" class="justify-content-start m-1" no-gutters><b>전시여부</b>
              <b-form-row style="padding-left: 35px;">
                <b-button id="popover-button-event1" variant="empty" class="simple-icon-info mt-1 d-inline" @click="openModal('showInfo')"></b-button>

              <b-col md="auto" style="padding-top: 13px;">
                <b-form-radio-group v-model="onSale" style="padding-left: 10px;">
                  <b-form-radio :value="true">전시함</b-form-radio>
                  <b-form-radio :value="false">전시 안함</b-form-radio>
                </b-form-radio-group>
              </b-col>
              </b-form-row>
            </b-row>

            <b-row align-v="center" class="justify-content-start m-1" no-gutters style="padding-top: 10px;"><b>테이블엔조이<br>전시여부</b>
              <b-form-row style="padding-left: 10px;">
                <b-button id="popover-button-event2" variant="empty" class="simple-icon-info mt-1 d-inline" @click="openModal('tnjShowInfo')"></b-button>
                <b-col md="auto" style="padding-top: 13px;">
                  <b-form-radio-group v-model="tnjOnSale" style="padding-left: 10px;" disabled>
                    <b-form-radio :value="true">전시함</b-form-radio>
                    <b-form-radio :value="false">전시 안함</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-form-row>
            </b-row>

            <b-row align-v="center" class="justify-content-start m-1" no-gutters style="padding-top: 10px;"><b>자체판매<br>전시여부</b>
              <b-form-row style="padding-left: 35px;">
                    <b-button id="popover-button-event3" variant="empty" class="simple-icon-info mt-1 d-inline" @click="openModal('selfShowInfo')"></b-button>
                <b-col md="auto" style="padding-top: 13px;">
                  <b-form-radio-group v-model="cloudOnSale" style="padding-left: 10px;">
                    <b-form-radio :value="true">전시함</b-form-radio>
                    <b-form-radio :value="false">전시 안함</b-form-radio>
                  </b-form-radio-group>
                </b-col>
              </b-form-row>
            </b-row>

          <br>

          <b-modal id="showInfo" ref="showInfo" size="lg" title="전시여부 도움말">
            <div class="modal-body form-horizontal">
              ㆍ전시안함 상태에서는 매장페이지 진입 및 상품구매가 불가능 합니다.<br>
              ㆍ전시안함으로 변경시 쿠폰 사용가능 매장에서 제외되며, 사용처리도 불가능 합니다.
            </div>
            <template slot="modal-footer">
              <b-button variant="outline-primary" @click="closeModal('showInfo')">닫기</b-button>
            </template>
          </b-modal>

          <b-modal id="tnjShowInfo" ref="tnjShowInfo" size="lg" title="테이블엔조이 전시여부 도움말">
            <div class="modal-body form-horizontal">
              ㆍ’전시함’으로 설정시, 테이블엔조이 플랫폼에서 노출됩니다.<br>
              ㆍ설정을 변경하고 싶은 경우 테이블엔조이 담당자에게 변경을 요청하세요
            </div>
            <template slot="modal-footer">
              <b-button variant="outline-primary" @click="closeModal('tnjShowInfo')">닫기</b-button>
            </template>
          </b-modal>

          <b-modal id="selfShowInfo" ref="selfShowInfo" size="lg" title="자체판매 전시여부 도움말">
            <div class="modal-body form-horizontal">
              ㆍ자체판매 사이트에서 매장 노출 여부를 결정합니다.
            </div>
            <template slot="modal-footer">
              <b-button variant="outline-primary" @click="closeModal('selfShowInfo')">닫기</b-button>
            </template>
          </b-modal>

          <div class="text-center">
            <b-button variant="primary" class="mt-4 ml-2" @click.prevent="onSave">저장</b-button>
          </div>
        </b-card>
      </b-colxx>
    </b-row>
    <b-button variant="outline-primary" class="mt-0" @click.prevent="goBack">뒤로</b-button>
  </div>
</template>

<script>
import PhoneNumber from "@/components/Business/SmsPhoneNumber";
import emailAddress from "@/components/Business/emailAddress";
import offeredOptions from "@/components/Business/offeredOptions";
import InputTag from "@/components/Form/InputTag";

import {
  mapGetters,
  mapActions, mapMutations
} from "vuex";

import api from "../../constants/api";
import {rescode} from "@/constants/common";

import {
  reqGet,
  reqPost
} from "../../constants/request";

export default {
  components: {
    'phone-number': PhoneNumber,
    'email-address': emailAddress,
    'offered-options': offeredOptions,
    'input-tag': InputTag,

  },
  data() {
    return {
      userRole: null,
      storeCode: this.$route.params.storeCode,
      onSale: false,
      tnjOnSale: false,
      cloudOnSale: false,
      show: false,
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'siteName'])

  },
  watch:{
    currentMenuSize(){
      let items = 0
      if(this.getMenuClickCount == '0'){
        items = '0'
      }else if(this.getMenuClickCount == '1' ){
        items = '1'
      }else if(this.getMenuClickCount == '2'){
        items = '2'
      }else if(this.getMenuClickCount == '3'){
        items = '1'
      }
      return items
    }
  },
  mounted() {
    this.userRole = this.currentUser.userRole.split('_')[0]
    this.loadData()
  },
  methods: {

    loadData() {

      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeDisplayQueryBRD)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeDisplayQuerySTR)
      }

      const params = {
        storeCode: this.storeCode
      }

      this.$http.get(reqURL, {
        params: params,
        headers: {
          'Authorization': `Bearer ${this.currentUser.tokens.access.token}`
        }
      }).then(res => {
        if (res.data.code === "OK") {
          this.onSale = res.data.data.onSale
          this.tnjOnSale = res.data.data.tnjOnSale
          this.cloudOnSale = res.data.data.cloudOnSale

        } else {
          throw 400
        }
      }).catch(err => {
        console.log(err);
      })



    },
    goBack() {
      this.$router.back();
    },
    onSave() {
      let reqURL = ''
      if (this.userRole == "BRAND") {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeDisplayUpdateBRD)
      } else {
        reqURL = api.changeAPI(this.siteName, api.basicURL + api.shop.storeDisplayUpdateSTR)
      }
      reqPost(
        reqURL,
        this.currentUser.tokens.access.token, {
          storeCode: this.$route.params.storeCode,
          display: {
            onSale: this.onSale,
            cloudOnSale: this.cloudOnSale
          }
        },
        (result) => {
          if (result != null) {
            if (result.code == rescode.REQ_SUCCESS) {
              alert('저장되었습니다.');
            } else {
              alert(result.message);
            }
          }
        }
      );
    },
    openModal(value){
      this.$refs[value].show();
    },
    closeModal(value) {
      this.$refs[value].hide();
    }


  }
}

</script>

<style>

</style>
